module.exports = __webpack_public_path__ + "img/冀州暖气输液器.55cef256.jpg";